module.exports = __webpack_public_path__ + "static/08-2de996010c686ea94d8dcd2eddb37675.jpg";